import { updateQuestionListByVariant } from "./fnaQuestionAccess.js";
import { normalizeZuuFnaQuestionList } from "./zuuFnaFieldMap.js";

type PreserveZuuCurrencySelectionOnAmountChangeOptions = {
  optionQuestionKey: string;
  selectedOption?: string;
  fallbackOptionValue?: string;
  amountQuestionKey: string;
  amountValue: any;
  clearAmountQuestionKeys?: string[];
};

export function preserveZuuCurrencySelectionOnAmountChange(
  list: any[] | undefined,
  options: PreserveZuuCurrencySelectionOnAmountChangeOptions,
) {
  const {
    optionQuestionKey,
    selectedOption,
    fallbackOptionValue,
    amountQuestionKey,
    amountValue,
    clearAmountQuestionKeys = [],
  } = options;
  let nextList = normalizeZuuFnaQuestionList(list || []);
  const nextSelectedOption = amountValue
    ? (fallbackOptionValue ?? selectedOption)
    : selectedOption;

  if (nextSelectedOption) {
    nextList = updateQuestionListByVariant(
      nextList,
      optionQuestionKey,
      nextSelectedOption,
      "RADIO",
      { isZuuMode: true },
    );
  }

  clearAmountQuestionKeys.forEach((questionKey) => {
    nextList = updateQuestionListByVariant(
      nextList,
      questionKey,
      undefined,
      "INPUT",
      { isZuuMode: true },
    );
  });

  return updateQuestionListByVariant(
    nextList,
    amountQuestionKey,
    amountValue,
    "INPUT",
    { isZuuMode: true },
  );
}
